import { CONST } from "../CONST";
import { MinigameScene } from "./generic/MinigameScene";

export class MarriageScene extends MinigameScene {
    //Images
    private endAnimationLose !: object;
    private endAnimationWin !: object;
    private endImage !: Phaser.GameObjects.Image;

    //values
    private clothesConfigs = [
        {imageName: CONST.MARRIAGE.SHIRT_1, startPos: {x: 121, y: 119}, dressedPos: {x: 427.5, y: 283}, type: 0, isRequired: true, scale: 1.0, depth: 11},
        {imageName: CONST.MARRIAGE.SHIRT_2, startPos: {x: 121, y: 338}, dressedPos: {x: 427.5, y: 283}, type: 0, isRequired: false, scale: 1.0, depth: 14},
        {imageName: CONST.MARRIAGE.SHIRT_3, startPos: {x: 121, y: 223.5}, dressedPos: {x: 427.5, y: 283}, type: 0, isRequired: false, scale: 1.0, depth: 12},
        {imageName: CONST.MARRIAGE.SHIRT_4, startPos: {x: 121, y: 392}, dressedPos: {x: 427.5, y: 266}, type: 0, isRequired: false, scale: 1.0, depth: 15},
        {imageName: CONST.MARRIAGE.SHIRT_5, startPos: {x: 121, y: 298}, dressedPos: {x: 427.5, y: 283}, type: 0, isRequired: false, scale: 1.2, depth: 13},

        {imageName: CONST.MARRIAGE.PANTS_1, startPos: {x: 749, y: 107}, dressedPos: {x: 426.5, y: 398}, type: 1, isRequired: true, scale: 1.0, depth: 11},
        {imageName: CONST.MARRIAGE.PANTS_2, startPos: {x: 749, y: 195}, dressedPos: {x: 425.5, y: 378}, type: 1, isRequired: false, scale: 1.0, depth: 14},
        {imageName: CONST.MARRIAGE.PANTS_3, startPos: {x: 749, y: 129}, dressedPos: {x: 426, y: 383.5}, type: 1, isRequired: false, scale: 1.0, depth: 12},
        {imageName: CONST.MARRIAGE.PANTS_4, startPos: {x: 749, y: 298}, dressedPos: {x: 425.5, y: 393}, type: 1, isRequired: false, scale: 1.0, depth: 15},
        {imageName: CONST.MARRIAGE.PANTS_5, startPos: {x: 749, y: 162}, dressedPos: {x: 426.5, y: 386}, type: 1, isRequired: false, scale: 1.0, depth: 13},

        {imageName: CONST.MARRIAGE.SHOES_1, startPos: {x: 681, y: 406}, dressedPos: {x: 423, y: 450}, type: 2, isRequired: false, scale: 1.0, depth: 11},
        {imageName: CONST.MARRIAGE.SHOES_2, startPos: {x: 590, y: 406}, dressedPos: {x: 423, y: 450}, type: 2, isRequired: true, scale: 1.0, depth: 11},
        {imageName: CONST.MARRIAGE.SHOES_3, startPos: {x: 766, y: 406}, dressedPos: {x: 423, y: 450}, type: 2, isRequired: false, scale: 1.0, depth: 11},

    ];

    private dressedPositions = [
        {type: 0, x: 426.5, y: 288},
        {type: 1, x: 426.5, y: 392},
        {type: 2, x: 426.5, y: 452},
    ];
    private maxDropDistance = 80;

    private animFPS = 60;


    //logic vars
    private clothes = [];
    private dressedClothes !: void[];

    private animTimer = 0;
    private isAnimating = false;
    private isWinAnimation = false;

    constructor(){
        super ({
            sceneName: CONST.SCENES.MARRIAGE,
            duration: 15000,
            startScreenColor: 0xEF91F0,
            startText: "GET\nMARRIED!",
            startTextYOrigin: 0.45,
            startTextColor: 0x323232,
            endScreen: CONST.MARRIAGE.END,
            nextScene: CONST.SCENES.KIDS,
            endButtons: {
                normalNoSkip: {x: 426.5, y: 411, scale: 1.30},
                normalWithSkip: {x: 283, y: 411, scale: 1.30},
                skip: {x: 570, y: 411, scale: 1.30}
            }
          })
    }
    _init(){
        //Reset all class variables that change during scene here (including arrays that initialize in create!)
        this.clothes = [];
        this.dressedClothes = Array.apply(null, Array(3)).map(function () {});

        this.animTimer = 0;
        this.isAnimating = false;
        this.isWinAnimation = false;
    }

    _preload(){
    }

    _create(){
        this.add.image(0, 0, CONST.MARRIAGE.BACKGROUND).setOrigin(0, 0).setDepth(0);
        this.add.image(563.5, 92.8, CONST.MARRIAGE.BACKGROUND_OVERLAY).setDepth(1);
        this.add.image(424, 297, CONST.MARRIAGE.HANDS).setDepth(20);

        this.createClothes();

        this.endAnimationWin = this.cache.json.get(CONST.ANIMATIONS.MARRIAGEWIN);
        this.endAnimationLose = this.cache.json.get(CONST.ANIMATIONS.MARRIAGEFROWN);
    }

    private createClothes(){
        //{imageName: CONST.MARRIAGE.SHIRT_1, startPos: {x: 100, y: 100}, dressedPos: {x: 100, y: 100}, type: 0, isRequired: false},

        this.clothesConfigs.forEach((clothesConfig) => {
            //Spawn clothes at startPos
            let cloth = this.add.image(clothesConfig.startPos.x, clothesConfig.startPos.y, clothesConfig.imageName)
                                .setInteractive({ useHandCursor: true})
                                .setScale(clothesConfig.scale, clothesConfig.scale)
                                .setDepth(clothesConfig.depth);

            cloth.config = clothesConfig;
            cloth.isDressed = false;

            cloth.setDressed = (dressed: boolean) => {
                cloth.isDressed = dressed;
                if (cloth.isDressed){
                    //Move to dressed position
                    cloth.x = cloth.config.dressedPos.x;
                    cloth.y = cloth.config.dressedPos.y;
                    cloth.setDepth(9);
                } else {
                    //Move to start position
                    cloth.x = cloth.config.startPos.x;
                    cloth.y = cloth.config.startPos.y;
                    cloth.setDepth(cloth.config.depth);
                }
            }

            cloth.dress = () => {
                cloth.setDressed(true);
                
                if (this.dressedClothes[cloth.config.type]){
                    //console.log("undressing current clothes");
                    this.dressedClothes[cloth.config.type].setDressed(false);
                }

                this.dressedClothes[cloth.config.type] = cloth;
            }

            this.input.setDraggable(cloth);
        });

        this.input.on('dragstart', function (pointer, gameObject) {
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
            if (gameObject.isDressed) return; 
            this.sound.play(CONST.AUDIO.GRAB, {detune: this.getDetune()});
        }, this);

        this.input.on('drag', function (pointer, gameObject, dragX, dragY) {
            if (gameObject.isDressed) return; 

            gameObject.x = dragX;
            gameObject.y = dragY;
        });

        this.input.on('dragend', function(pointer, gameObject, dropped){
            if (!this.isCurrentState(CONST.GAMESTATE.PLAYING)) return;
            if (gameObject.isDressed) return; 

            this.tryDress(gameObject);
        }, this);

    }

    private tryDress(gameObject: Phaser.GameObjects.Image){
        this.dressedPositions.forEach((pos) => {
            if (pos.type == gameObject.config.type){
                if (Phaser.Math.Distance.Between(pos.x, pos.y, gameObject.x, gameObject.y) <= this.maxDropDistance){
                    gameObject.dress();
                    this.sound.play(CONST.AUDIO.BOUNCE, {detune: this.getDetune()});

                    if (this.checkForWin()){
                        this.triggerWin();
                    }
                } else {
                    this.sound.play(CONST.AUDIO.GRAB, {detune: this.getDetune()});
                }
            }
        })
    }

    _update(time: number, delta: number){
        if (this.isAnimating){
            this.animTimer += delta;
            if (this.isWinAnimation){
                this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimationWin);
            } else {
                this.positionImageOnAnimation(this.animTimer, this.endImage, this.endAnimationLose, 0, -100);
            }
        }
    }

    _timeout(){
        if (this.checkForWin()){
            this.triggerWin();
        } else {
            this.triggerLoss();
        }
    }
    
    private checkForWin() : boolean{
        for (var i = 0; i < this.dressedClothes.length; i++){
            if (this.dressedClothes[i] == null || !this.dressedClothes[i].config.isRequired){
                return false;
            }
        }

        return true;
    }

    _afterLoss(){
    }

    _afterWin(){
    }

    private triggerLoss(){
        this.loseGame(1000);
        this.endGameAnim(false);
    }

    private triggerWin(){
        //trigger win after 1 second and load next scene
        this.winGame(1500);
        this.endGameAnim(true);
    }

    private endGameAnim(win: boolean){
        this.isWinAnimation = win;
        var imageKey = win ? CONST.MARRIAGE.WINIMAGE : CONST.TALK.SMILE;
        this.endImage = this.add.image(0, 0, imageKey).setScale(0, 0).setDepth(900);
        this.animTimer = 0;
        this.isAnimating = true;
    }

    private positionImageOnAnimation(timer: number, image: Phaser.GameObjects.Image, animation: object, xOffset: number = 0, yOffset: number = 0, angleOffset: number = 0, scaleMultiplier: number = 1){
        //Get frame
        var frameIndex = Math.floor(timer * (this.animFPS / 1000));
        if (frameIndex >= animation.frames.length){
            frameIndex = animation.frames.length - 1;
        }

        var frame = animation.frames[frameIndex];

        //position image to frame
        image.setPosition(frame.x + xOffset, frame.y + yOffset)
            .setScale(parseFloat(frame.scaleX) * scaleMultiplier, parseFloat(frame.scaleY) * scaleMultiplier)
            .setAngle(parseFloat(frame.angle) + angleOffset);
    }

}
